import { useState, useEffect } from 'react'
import { useDebouncedValue } from '@luuna/shared'
import { useQueryParamState, UseQueryParamStateProps } from './use-query-param-state'

export type UseDebouncedSearchOptions = UseQueryParamStateProps & {
  delay?: number
  onSearchChange?: (search: string) => void
}

export function useDebouncedSearch({ delay = 500, onSearchChange, ...queryParamOptions }: UseDebouncedSearchOptions) {
  const [queryParamSearch, setQueryParamSearch] = useQueryParamState(queryParamOptions)
  const [localSearch, setLocalSearch] = useState(queryParamSearch)
  const debouncedLocalSearch = useDebouncedValue(localSearch, delay)

  // Update query param when debounced local search changes
  useEffect(() => {
    setQueryParamSearch(debouncedLocalSearch)
  }, [debouncedLocalSearch, setQueryParamSearch])

  // Call callback when query param changes
  useEffect(() => {
    onSearchChange?.(queryParamSearch)
  }, [queryParamSearch])

  return {
    search: localSearch,
    setSearch: setLocalSearch,
    debouncedSearch: queryParamSearch,
  }
}
